<template>
    <a class="btn btn-sm btn-outline-info" @click="exportAudit">Download Audit</a>
</template>

<script>
    export default {
        name: "ExportAudit",
        props: ['client_id', 'month', 'year'],
        data() {
            return {
                client:null
            }
        },
        created() {
            axios.post('/admin/client',{'client':this.client_id}).then(response => {
                this.client = response.data;
            });
        },
        methods: {
            exportAudit: function () {
                this.api_config = {
                    headers: {
                        'Authorization': 'Bearer ' + this.client.api_token,
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                    },
                    'responseType': 'blob'
                }
                axios.post(this.client.api + '/reports/audit',{
                    month:this.month,
                    year:this.year,
                    client_code:this.client.client_code
                }, this.api_config).then(response=>{
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', this.client.client_code + '-Invoice-Audit-' + this.month + this.year + '.csv');
                    document.body.appendChild(link);
                    link.click();
                })
            }
        }
    }
</script>

<style scoped>

</style>
